export interface CurrencyStyle {
  color: string;
  fontSize: string;
  fontWeight: string;
  textAlign: string;
  textShadow?: string;
}
